import { Directive, Input, ElementRef, AfterContentInit } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { AnalyticsService } from './analytics.service';

@Directive({
  standalone: false,
  selector: '[tiOpenPanelEvent]',
})
export class OpenPanelEventDirective implements AfterContentInit {
  @Input() tiOpenPanelEvent: string;
  @Input() tiOpenPanelAction: string;
  @Input() tiOpenPanelCategory: string;
  @Input() tiOpenPanelProperties: any;
  private el: any;

  constructor(
    private elRef: ElementRef,
    private analytics: AnalyticsService,
    private eventManager: EventManager,
  ) {
    this.el = this.elRef.nativeElement;
  }

  ngAfterContentInit() {
    if (typeof window !== 'undefined') {
      this.eventManager.addEventListener(this.el, this.tiOpenPanelEvent || 'click', (event?: any) =>
        this.eventTrack(event),
      );
    }
  }

  eventTrack(event) {
    const action = this.tiOpenPanelAction;
    let properties: any = {};

    if (this.tiOpenPanelCategory) {
      properties.category = this.tiOpenPanelCategory;
    }
    if (this.tiOpenPanelProperties) {
      Object.assign(properties, this.tiOpenPanelProperties);
    }

    this.analytics.eventTrack.next({ action, properties });
  }
}
